module.exports = __webpack_public_path__ + "img/s2-0-s.c20b527f.svg";